import { CLASSROOM_MODULE_GET_VERSION } from '../actions';
import { getVersion as apiGetVersion } from '../api';
import * as classRoomSelectors from '../../selectors/classroom';

const getVersionAction = (status, payload) => ({
  type: CLASSROOM_MODULE_GET_VERSION,
  status,
  payload,
});

const getVersionStarted = getVersionAction.bind(null, 'started');
const getVersionSuccess = getVersionAction.bind(null, 'success');
const getVersionError = getVersionAction.bind(null, 'error');
const getVersionAbort = getVersionAction.bind(null, 'aborted');

const getVersion =
  ({ sectionId, versionId }) =>
  async (dispatch, getState) => {
    const state = getState();
    const classRoomId = classRoomSelectors.currentClassRoomId(state);

    dispatch(getVersionStarted({ versionId }));

    if (!sectionId || !classRoomId || !versionId) {
      dispatch(getVersionAbort());
    }

    try {
      const version = await apiGetVersion(classRoomId, sectionId, versionId);
      dispatch(getVersionSuccess({ content: version }));
    } catch (error) {
      // This means the request was cancelled by selecting a new version.
      if (error.message !== 'Newer request.') {
        dispatch(getVersionError(error));
      }
    }
  };

export default getVersion;
